import React from "react";
import { ErrorIconBlack } from "src/Components/Common";

import "./WithPopup.css";

//TODO: add better props (message, type, onClick)
const WithPopup = props => {
    return <div className="with-popup-container">
      { props.warningMsg
        ? <div className='with-popup-error-bar'>
            <div className='with-popup-error-bar-content'>
              <div className='with-popup-error-bar-icon'>
                <ErrorIconBlack />
              </div>
              <div className="with-popup-error-bar-text">
                { props.warningMsg }
              </div>
            </div>
            <div className="with-popup-error-bar-dismiss" onClick={props.warningMsgOnclick}>
                Dismiss
            </div>
          </div>
        : props.infoMessage
        ? <div className='with-popup-info-bar'>
            <div className='with-popup-info-bar-content'>
              <div className="with-popup-info-bar-text">
                { props.infoMessage }
              </div>
            </div>
            <div className="with-popup-info-bar-dismiss" onClick={props.infoMsgOnclick}>
                Dismiss
            </div>
          </div>
        : null
      }
      <div className="with-popup-backdrop"> </div>
      <div style={props.contentStyle}>{props.children}</div>
    </div>;
}

export default WithPopup;
